import { useState } from 'react'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined'
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined'
import { AppBar, IconButton, Sidebar } from 'src/lib'
import { AssistentButton } from 'src/lib/components/complex/AssistentButton'
import { StreamFinIcon } from 'src/lib/icons'
import { intl } from 'src/internationalization/intl'
import { AdvisorDashboard } from 'src/pages/AdivisorDashboard'
import { DataImport } from 'src/pages/DataImport'
import { useDrawerStore } from 'src/store/drawerStore'
import { useSidebarStore } from 'src/store/sidebarStore'
import { useUserStore } from 'src/store/userStore'
import { useIsMobile } from 'src/lib/hooks/useIsMobile'
import { isManagerProfile } from 'src/lib/utils/isManagerProfile'
import { canUploadDocuments } from 'src/lib/utils/canUploadDocuments'
import { isDesignMode } from 'src/config/designMode'

const DashboardShell = () => {
    const open = useDrawerStore((s: any) => s.open)
    const isFullscreen = useDrawerStore((s: any) => s.isFullscreen)
    const toggle = useDrawerStore((s: any) => s.toggle)
    const chatWidth = useDrawerStore((s: any) => s.width)
    const isResizing = useDrawerStore((s: any) => s.isResizing)
    const setMobileOpen = useSidebarStore((s: any) => s.setMobileOpen)
    const isMobile = useIsMobile()
    const { user } = useUserStore()
    const isManager = isManagerProfile(user?.profile)
    const canUpload = canUploadDocuments(user?.groups)
    const [view, setView] = useState<'dashboard' | 'import'>('dashboard')
    const [managerTab, setManagerTab] = useState<'advisor' | 'manager'>('advisor')

    const userPosition = isManager && managerTab === 'manager' ? 'Gestor Sênior' : 'Assessoria Sênior'

    const profileMenuOptions = isManager
        ? [
            {
                id: 'advisor',
                label: intl('panelTitle'),
                selected: managerTab === 'advisor',
                onSelect: () => { setView('dashboard'); setManagerTab('advisor') },
            },
            {
                id: 'manager',
                label: intl('managerPanelTitle'),
                selected: managerTab === 'manager',
                onSelect: () => { setView('dashboard'); setManagerTab('manager') },
            },
        ]
        : undefined

    return (
        <>
            <Sidebar.Root
                footer={
                    <Sidebar.Profile
                        userName={user?.name || ''}
                        userPosition={userPosition}
                        avatarName={user?.name || 'U'}
                        menuOptions={profileMenuOptions}
                    />
                }
            >
                {canUpload && (
                    <Sidebar.Item
                        icon={<CloudUploadOutlinedIcon />}
                        label={intl('importData')}
                        selected={view === 'import'}
                        onClick={() => setView('import')}
                    />
                )}
            </Sidebar.Root>
            {view === 'dashboard' ? (
                <>
                    <AppBar
                        open={open && !isFullscreen}
                        chatWidth={chatWidth}
                        isResizing={isResizing}
                        icon={<StreamFinIcon />}
                        brandName="StreamFin"
                        badgeText={isDesignMode ? "MODO DESIGN" : undefined}
                        onMenuClick={isMobile ? () => setMobileOpen(true) : undefined}
                    >
                        {!open && <AssistentButton onClick={toggle} />}
                    </AppBar>
                    <AdvisorDashboard managerTab={managerTab} />
                </>
            ) : (
                <>
                    <AppBar
                        open={open && !isFullscreen}
                        chatWidth={chatWidth}
                        isResizing={isResizing}
                        icon={<StreamFinIcon />}
                        brandName="StreamFin"
                        badgeText={isDesignMode ? "MODO DESIGN" : undefined}
                        onMenuClick={isMobile ? () => setMobileOpen(true) : undefined}
                    >
                        <IconButton variant="clean" color="neutral" onClick={() => setView('dashboard')}>
                            <HomeOutlinedIcon />
                        </IconButton>
                    </AppBar>
                    <DataImport />
                </>
            )}
        </>
    )
}

export { DashboardShell }
